import React from 'react';

/** Displays a FontAwesome icon. */
export default class Icon extends React.PureComponent<{ icon: string; }> {
  render() {
    return <i className={`fa fa-${this.props.icon}`} />;
  }
}
